import { __extends } from "tslib";
import { GetAppRequest, GetAppResponse } from "../models/models_0";
import { deserializeAws_restJson1GetAppCommand, serializeAws_restJson1GetAppCommand } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetAppCommand = /** @class */ (function (_super) {
    __extends(GetAppCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetAppCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetAppCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "PinpointClient";
        var commandName = "GetAppCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: GetAppRequest.filterSensitiveLog,
            outputFilterSensitiveLog: GetAppResponse.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetAppCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1GetAppCommand(input, context);
    };
    GetAppCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1GetAppCommand(output, context);
    };
    return GetAppCommand;
}($Command));
export { GetAppCommand };
//# sourceMappingURL=GetAppCommand.js.map